import DaggerIcon from "./DaggerIcon";
import { TRUST_COLOR, BETRAY_COLOR } from "../theme";

function Logo({ size = 32 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0px" }}>
      <span style={{ fontSize: size, fontWeight: 800, color: TRUST_COLOR }}>trust</span>
      <DaggerIcon size={size * 1.6} />
      <span style={{ fontSize: size, fontWeight: 800, color: BETRAY_COLOR }}>game</span>
    </div>
  );
}

export default Logo;
